import React, {ChangeEvent, FunctionComponent} from 'react';
import './styles.scss';
import {FormattedMessage} from 'react-intl';

interface IInputCheckbox {
  value: boolean
  onChange: (value: boolean) => void
  label: string
  required?: boolean
  error?: { id: string; defaultMessage: string } | null
}

export const InputCheckbox: FunctionComponent<IInputCheckbox> = ({
  value,
  onChange,
  label,
  error
}: IInputCheckbox) => {
  function handleChangeCheckbox(e: ChangeEvent<HTMLInputElement>) {
    onChange(e.target.checked);
  }

  return <>
    <div className="input-checkbox">
      <input
        id={'input-checkbox'}
        className='input-checkbox__field'
        type='checkbox'
        checked={value}
        onChange={handleChangeCheckbox}
      />
      <label
        className='input-checkbox__label'
        htmlFor={'input-checkbox'}>
        {label}
      </label>
    </div>
    <div className="input-checkbox__error">
      {error && <FormattedMessage {...error}/>}
    </div>
  </>;
};
